import { useEffect, useState } from 'react'
import { z } from 'zod'
import type { DidYouKnowResult } from '../data/DidYouKnowFragment'

const LOCAL_STORAGE_NAME = 'granulepodlupou-did-you-know'

export function useDidYouKnowCheck(items: DidYouKnowResult[]) {
	const [publishedItem, setPublishedItem] = useState(items[0])

	useEffect(() => {
		const savedItems = localStorage.getItem(LOCAL_STORAGE_NAME)
		const firstNotSeenItem = items.find((item) => !savedItems?.includes(item.id))

		const saveToStorage = (item: DidYouKnowResult) => {
			const savedItems = localStorage.getItem(LOCAL_STORAGE_NAME)
			const toSave = savedItems ? [...z.array(z.string()).parse(JSON.parse(savedItems)), item.id] : [item.id]
			const withoutDuplicity = new Set(toSave)
			localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify([...withoutDuplicity]))
		}

		if (firstNotSeenItem) {
			saveToStorage(firstNotSeenItem)
			setPublishedItem(firstNotSeenItem)
		} else {
			localStorage.removeItem(LOCAL_STORAGE_NAME)
			saveToStorage(items[0])
			setPublishedItem(items[0])
		}
	}, [items])

	return publishedItem
}
